import React from "react"
import { Link } from "gatsby"

export const CTAButton = ({ label, link, href, mobile }) => {
  return (
    <div className={`${mobile ? "m-auto" : "my-auto"}`}>
      {href ? (
        <a
          href={href}
          className="button is-sonnengelb"
          target="_blank"
          rel="noopener noreferrer"
        >
          {label}
        </a>
      ) : (
        <Link to={link} className="button is-sonnengelb">
          {label}
        </Link>
      )}
    </div>
  )
}
